<script lang="ts">
  export let open: boolean = false;
  export let reason: string = '';
  export let onSubmit: () => void = () => {};
  export let onCancel: () => void = () => {};
</script>

{#if open}
  <div class="modal-backdrop">
    <div class="modal-card">
      <h2 class="modal-title">Reject Donation Request</h2>
      <p class="modal-desc">Please provide a reason for rejecting this donation request.</p>
      <label class="modal-label" for="reject-reason">Reason</label>
      <textarea
        id="reject-reason"
        class="modal-textarea"
        placeholder="Enter your reason for rejection"
        bind:value={reason}
        rows={4}
      ></textarea>
      <div class="modal-actions">
        <button class="confirm-btn" on:click={onSubmit}>Submit Rejection</button>
        <button class="cancel-btn" on:click={onCancel}>Cancel</button>
      </div>
    </div>
  </div>
{/if}

<style>
  .modal-backdrop {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(31, 41, 55, 0.4);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .modal-card {
    background: #fff;
    border-radius: 18px;
    box-shadow: 0 4px 32px rgba(0,0,0,0.12);
    padding: 40px 32px 32px 32px;
    width: 564px;
    height: 504px;
    max-width: 95vw;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .modal-title {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 8px;
    text-align: center;
    color: #111827;
  }
  .modal-desc {
    font-size: 1rem;
    color: #374151;
    margin-bottom: 24px;
    text-align: center;
  }
  .modal-label {
    font-size: 1rem;
    color: #111827;
    font-weight: 500;
    align-self: flex-start;
    margin-bottom: 8px;
  }
  .modal-textarea {
    width: 100%;
    min-height: 100px;
    border-radius: 10px;
    border: 1px solid #e5e7eb;
    padding: 16px;
    font-size: 1rem;
    color: #111827;
    margin-bottom: 32px;
    resize: none;
    background: #fafbfc;
    box-sizing: border-box;
  }
  .modal-textarea::placeholder {
    color: #9ca3af;
    opacity: 1;
  }
  .modal-actions {
    display: flex;
    flex-direction: column;
    gap: 18px;
    width: 100%;
  }
  .confirm-btn {
    width: 100%;
    height: 52px;
    border-radius: 100px;
    background: #ffc107;
    color: #111827;
    font-size: 1.1rem;
    font-weight: 600;
    border: none;
    cursor: pointer;
    margin-bottom: 0;
    transition: background 0.2s;
  }
  .confirm-btn:hover {
    background: #f59e0b;
  }
  .cancel-btn {
    width: 100%;
    height: 52px;
    border-radius: 100px;
    background: #e5e7eb;
    color: #374151;
    font-size: 1.1rem;
    font-weight: 600;
    border: none;
    cursor: pointer;
    margin-bottom: 0;
    transition: background 0.2s;
  }
  .cancel-btn:hover {
    background: #d1d5db;
  }
</style> 